import { Paper, Typography } from '@mui/material';

const MainContent = () => {
  return (
    <Paper elevation={3} sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Unified Defense Order Management Portal
      </Typography>
      <Typography variant="body1" paragraph>
        Welcome to the portal. This system allows you to manage defense orders efficiently.
      </Typography>
      <Typography variant="body1" paragraph>
        Use the menu to navigate between different sections of the application.
      </Typography>
    </Paper>
  );
};

export default MainContent;
